import { combineReducers } from 'redux';

const initialState = {
  specials: {},
};

function specialsReducer(state = initialState.specials, action) {
  switch (action.type) {
    case 'LOAD_SPECIAL_COMPLETION': {
      const { specialId, data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [specialId]: data,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  specials: specialsReducer,
});
